// Lets the header open the softphone connection alert — e.g. when the status shows
// Un-Register but no failure was recorded, as after a reload.
//
// WHY MODULE-LEVEL (the same reasoning as utils/mediaLiveness.js)
// The alert and the SIP stack it drives both live in CallingSidebar, but the status the
// agent clicks on lives in Header — a different tree. A ref cannot span those, and a
// Redux flag would be persisted with the rest of the `dial` slice (see store.js), so a
// stale "open" could survive a reload. A plain subscription resets on reload.

const openRequestSubscribers = new Set();

export const subscribeSipAlertRequest = (cb) => {
  openRequestSubscribers.add(cb);
  return () => openRequestSubscribers.delete(cb);
};

export const requestSipAlert = () => {
  openRequestSubscribers.forEach((cb) => {
    try {
      cb();
    } catch (error) {
      console.log('sipAlert subscriber error', error);
    }
  });
};
